import script from "./autoplay_image_dragger.vue?vue&type=script&setup=true&lang=js"
export * from "./autoplay_image_dragger.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__